/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as s from "react";
import i from "prop-types";
import { classNames as p } from "@progress/kendo-react-common";
const e = class e extends s.PureComponent {
  constructor() {
    super(...arguments), this._element = null;
  }
  /**
   * Returns the HTML element of the ToolbarItem component.
   */
  get element() {
    return this._element;
  }
  /**
   * @hidden
   */
  render() {
    return /* @__PURE__ */ s.createElement(
      "div",
      {
        id: this.props.id,
        className: p("k-toolbar-item", this.props.className),
        style: this.props.style,
        ref: (r) => this._element = r
      },
      this.props.children
    );
  }
};
e.propTypes = {
  className: i.string
};
let t = e;
export {
  t as ToolbarItem
};
